var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosingQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2514 32.6882C28.2917 30.0495 31.9367 25.0556 32.332 21.0212C32.2002 21.0212 31.3219 21.152 30.6851 21.152C27.1499 21.152 24.6247 18.5133 24.6247 14.7515C24.6188 13.8764 24.7881 13.0089 25.1226 12.1993C25.4571 11.3898 25.9502 10.6542 26.5732 10.0354C27.1963 9.41664 27.9369 8.92693 28.7521 8.59472C29.5673 8.26252 30.4408 8.09443 31.3219 8.10023C35.4939 8.10023 39.15 11.4913 39.15 17.641C39.15 25.2846 34.7583 32.3175 28.9175 36.45L24.2514 32.6882ZM4.04995 32.6882C8.09024 30.0495 11.6255 25.0556 12.1305 21.0212C11.9988 21.0212 11.1205 21.152 10.4837 21.152C9.64613 21.1638 8.81511 21.0043 8.04233 20.6833C7.26955 20.3624 6.57154 19.887 5.99174 19.2866C5.41194 18.6862 4.96275 17.9738 4.67213 17.1936C4.38151 16.4134 4.25568 15.5821 4.30247 14.7515C4.31986 12.972 5.04762 11.2721 6.32594 10.025C7.60425 8.77797 9.32864 8.0857 11.1205 8.10022C15.2815 8.10023 18.9485 11.4804 18.9485 17.6301C18.9485 25.2627 14.5569 32.3066 8.71604 36.4391L4.04995 32.6882Z",
    fill: "#E42436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosingQuotes);
export default __webpack_public_path__ + "static/media/closing-quotes.9048014a8787af775ff0a82d7e9b30c0.svg";
export { ForwardRef as ReactComponent };